import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { DateTimeCell, OverridableDateTimeCell } from '~src/spacesPlatform/components/ListView/dataGridCells/DateTimeCells';

import { Messages } from '../../../../codegen/Localize';
import { CreateCellText } from '../../../../spacesPlatform/components/ListView/dataGridCells/PlainTextAndNumberCells';
import { StyledCellFormatter } from '../../../../spacesPlatform/components/ListView/StyledCellWrapper';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ISubscriptionInfo } from '../../../models/ISubscriptionInfo';

export function SubscriptionNextUpdateDescriptionCell(): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function SubscriptionNextUpdateDescriptionCell(props: BodyCell.Props) {
        const row = props.row;
        const subscription = row.data as ISubscriptionInfo;
        if (subscription.refreshExtractTriggered != null
            && subscription.refreshExtractTriggered) {
          return CreateCellText(Messages.subscriptionOnExtractRefreshNextUpdate());
        } else if (FeatureFlags.suspendSubscriptions) {
          return OverridableDateTimeCell('runNextAt', 'suspended', Messages.disabled())(props);
        } else {
          return DateTimeCell('runNextAt', Messages.disabled())(props);
        }
      }
  );
}
